import { render, staticRenderFns } from "./EditBalloon.vue?vue&type=template&id=f1b9200a"
import script from "./EditBalloon.vue?vue&type=script&lang=js"
export * from "./EditBalloon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports